import { GET_ALL_AGE_GROUP } from '../../types'

const INITIAL_STATE = {
  getAllAgeGroup: [],
}

const ageGroupReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_AGE_GROUP:
      return {
        ...state,
        getAllAgeGroup: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default ageGroupReducer
